"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf4 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _form = _interopRequireDefault(require("./form"));

var _textField = _interopRequireDefault(require("../fields/text-field"));

var _formField = _interopRequireDefault(require("../fields/form-field"));

var _whereField = _interopRequireDefault(require("../fields/where-field"));

var ValidatorError =
/*#__PURE__*/
function (_Form) {
  (0, _inherits2.default)(ValidatorError, _Form);

  function ValidatorError() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ValidatorError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf4.default)(ValidatorError)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'ValidatorError');
    return _this;
  }

  (0, _createClass2.default)(ValidatorError, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf4.default)(ValidatorError.prototype), "_create", this).call(this, props);
      this.addField(new _textField.default({
        name: 'field',
        label: 'Field',
        required: true
      }));
      this.addField(new _textField.default({
        name: 'error',
        label: 'error',
        required: true
      }));
    }
  }]);
  return ValidatorError;
}(_form.default);

var FormValidator =
/*#__PURE__*/
function (_Form2) {
  (0, _inherits2.default)(FormValidator, _Form2);

  function FormValidator() {
    var _getPrototypeOf3;

    var _this2;

    (0, _classCallCheck2.default)(this, FormValidator);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf3 = (0, _getPrototypeOf4.default)(FormValidator)).call.apply(_getPrototypeOf3, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_className", 'FormValidator');
    return _this2;
  }

  (0, _createClass2.default)(FormValidator, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf4.default)(FormValidator.prototype), "_create", this).call(this, props);
      this.addField(new _whereField.default({
        name: 'where',
        label: 'Where',
        required: true
      }));
      this.addField(new _formField.default({
        name: 'error',
        label: 'Error',
        form: new ValidatorError(),
        required: true
      }));
    }
  }]);
  return FormValidator;
}(_form.default);

exports.default = FormValidator;